"use client"

import { useEffect, useState } from "react"
import { PrismicNextImage } from "@prismicio/next"
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import type { ImageField } from "@prismicio/client"

const SESSION_KEY = "shrikalikapeetam:page-modal-dismissed:v1"
let dismissedWithoutStorage = false

export function PageLoadModal({ image }: { image: ImageField }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    // Defer until hydration and cancel the first setup in React Strict Mode.
    const timeout = window.setTimeout(() => {
      try {
        if (window.sessionStorage.getItem(SESSION_KEY)) return
      } catch {
        // Keep dismissal working when browser storage is unavailable.
        if (dismissedWithoutStorage) return
      }
      setOpen(true)
    }, 0)

    return () => window.clearTimeout(timeout)
  }, [])

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      try {
        window.sessionStorage.setItem(SESSION_KEY, "true")
      } catch {
        dismissedWithoutStorage = true
      }
    }
    setOpen(nextOpen)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-h-[90dvh] w-fit overflow-y-auto p-3 pt-12 sm:max-w-4xl"
        aria-describedby={undefined}
      >
        <DialogTitle className="sr-only">
          Shri Kalikaa Peetam announcement
        </DialogTitle>
        <PrismicNextImage
          field={image}
          className="h-auto max-h-[80dvh] w-full rounded-lg object-contain"
          sizes="(max-width: 640px) 100vw, 672px"
        />
      </DialogContent>
    </Dialog>
  )
}
